import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNamad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={92}
    height={101}
    fill='none'
    {...props}
  >
    <path fill='url(#namad_svg__a)' d='M0 .017h91.912v100H0z' />
    <defs>
      <pattern id='namad_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#namad_svg__b' transform='scale(.008 .00735)' />
      </pattern>
      <image
        xlinkHref='/images/icons/namad-8a5fde24.webp'
        id='namad_svg__b'
        width={125}
        height={136}
      />
    </defs>
  </svg>
);
export default SvgNamad;
